import { Typography } from '@euler/app/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import { View } from 'react-native';

export const TagBadge = memo(({ label }: { label: string }) => {
  const { rpx } = useResponsiveContext();
  return (
    <View
      css={`
        height: ${rpx(20)}px;
        border-radius: ${rpx(4)}px;
        padding: 0 ${rpx(8)}px;
        background-color: #ffffff;
        border-width: ${rpx(1)}px;
        border-color: #e5e7eb;
        justify-content: center;
        margin-right: ${rpx(6)}px;
      `}
    >
      <Typography.Label size={rpx(11)} lineHeight={rpx(15)} color="#4b5563">
        {label}
      </Typography.Label>
    </View>
  );
});
